export default __webpack_public_path__ + "static/media/instagram.5115d871.jpg";